import axios from 'axios';

const UTILITY_SERVICE_BASE_URL = process.env.REACT_APP_UTILITY_SERVICE_BASE_URL;

// Report PDFs now live in a private GCS bucket, so a previously-public-looking
// gs://... or storage.googleapis.com/... URL/path can no longer be opened
// directly — it 403s. This pulls out the file's path relative to the bucket
// (what the signing endpoint calls "fileName") from whatever shape the API
// still returns it in.
export function extractGcsFileName(urlOrPath) {
  if (!urlOrPath || typeof urlOrPath !== 'string') return null;

  const gsMatch = urlOrPath.match(/^gs:\/\/[^/]+\/(.+)$/);
  if (gsMatch) return decodeURIComponent(gsMatch[1]);

  try {
    const parsed = new URL(urlOrPath);
    const segments = parsed.pathname.split('/').filter(Boolean);
    segments.shift(); // drop the bucket name
    return decodeURIComponent(segments.join('/'));
  } catch {
    // Not an absolute URL — assume it's already a bucket-relative path.
    return urlOrPath.replace(/^\/+/, '');
  }
}

// Exchanges a (possibly now-private) report URL/path for a fresh signed URL
// that's actually usable for viewing/downloading/sharing. Returns null if the
// input is empty or the exchange fails.
export async function resolvePdfUrl(urlOrPath) {
  const fileName = extractGcsFileName(urlOrPath);
  if (!fileName) return null;
  try {
    const res = await axios.get(`${UTILITY_SERVICE_BASE_URL}api/gcp/document-url`, {
      params: { fileName },
    });
    return res.data?.SIGNED_URL || null;
  } catch (err) {
    console.error('Failed to resolve signed PDF URL for', fileName, err);
    return null;
  }
}
